import createAction from "./utils/createMetaAction";
import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
export const updateSelectedFragment = createAction("updateSelectedFragment");
export const updateComputePartialDigest = createAction(
  "updateComputePartialDigest"
);
export default createMergedDefaultStateReducer(
  {
    [updateSelectedFragment]: (state, payload) => {
      return {
        ...state,
        selectedFragment: payload
      };
    },
    [updateComputePartialDigest]: (state, payload) => {
      return {
        ...state,
        computePartialDigest: payload
      };
    }
  },
  {
    selectedFragment: void 0,
    computePartialDigest: false
  }
);
